<mat-card-header>
	<mat-card-title>
		Service Administation
		<help-text-btn class="align-help-text-btn"
			[helpTextId]="'SearchServiceAdministration_Overview'"></help-text-btn>
	</mat-card-title>
</mat-card-header>
<mat-divider> </mat-divider>

<mat-card-content class="row margin-top-sm">
	<mat-card class="col-lg-6">
		<div class="">
			<mat-card-header>
				<mat-card-title>
					Search Criteria
				</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<region-dropdown-two-way [(selectedRegions)]="this.chosenRegions" [reset]="resetField"
					[isMultiple]="false" [required]="true">
				</region-dropdown-two-way>

			</mat-card-content>
			<mat-card-header>
				<mat-card-title>
					Filters
				</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div class="row">
					<mat-checkbox [color]="'primary'" class="checkbox-margin-sm" [(ngModel)]="activeServicesOnly">
						Active Services Only</mat-checkbox>
					<mat-checkbox [color]="'primary'" class="checkbox-margin-sm" [(ngModel)]="disabledServicesOnly">
						Disabled Services Only</mat-checkbox>
					<mat-checkbox [color]="'primary'" class="checkbox-margin-sm" [(ngModel)]="mpoServicesOnly">
						Services with MPOs Only</mat-checkbox>
				</div>
			</mat-card-content>
		</div>
		<mat-card-actions class="col-lg-12">
			<button mat-raised-button color="primary" mat-button [disabled]="!this.checkValid() || isLoading"
				(click)="search()" class="margin-right-xs">
				<mat-icon *ngIf="isLoading">
					<mat-spinner diameter="18"> </mat-spinner>
				</mat-icon>
				Search
			</button>
			<button mat-raised-button color="accent" (click)="reset()" mat-button>Reset</button>
		</mat-card-actions>

		<app-msg [msg]="msg" *ngIf="!msg.SUCCESS"></app-msg>
	</mat-card>

</mat-card-content>
<div class="margin-top-md">
	<mat-card-header>
		<mat-card-title>
			Existing Services - ({{(
			tableDataSource ? (tableDataSource.filteredData.length < results.length ?
				tableDataSource.filteredData.length + '/' : '' ) : '' ) + results.length}} Service(s)) </mat-card-title>
	</mat-card-header>
	<hr />

	<div class="row">
		<mat-form-field class="col-lg-12">
			<mat-label>
				Filter
			</mat-label>
			<input matInput id="filter" name="filter" type="string" [(ngModel)]="filter"
				(ngModelChangeDebounced)="setFilter()" />
		</mat-form-field>
	</div>

	<div class="margin-top-sm table-responsive">
		<mat-table [dataSource]="tableDataSource" class="mat-elevation-z1" matSort
			(matSortChange)="announceSortChange($event)">

			<ng-container matColumnDef="ADD_EDIT">
				<mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
				<mat-cell *matCellDef="let element">
					<button mat-icon-button color="primary" matTooltip="View" (click)="openDialog('View', element.ID)"
						*ngIf="featurePermissions['View Service Administrations']">
						<mat-icon>visibility</mat-icon>
					</button>
					<button mat-icon-button color="primary" matTooltip="Edit"
						(click)="openDialog('Edit', element.ID, element.SERVICE_NAME)"
						*ngIf="element.FEDERAL_CODES?.SERVICE_CODE != element.SERVICE_CODE && featurePermissions['Edit Service Administrations']">
						<mat-icon>edit</mat-icon>
					</button>
					<button mat-icon-button color="warn" matTooltip="Delete"
						(click)="openDeleteDialog(element.ID, element.SERVICE_NAME)"
						*ngIf="element.FEDERAL_CODES?.SERVICE_CODE != element.SERVICE_CODE && featurePermissions['Delete Service Administrations']">
						<mat-icon>delete</mat-icon>
					</button>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="PARTY_SERVICE_STATUS_TYPES.TYPE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Active/Disabled </mat-header-cell>
				<mat-cell *matCellDef="let element" class="justify-center">
					<button mat-icon-button color="primary" matTooltip="Toggle Status"
						*ngIf="element.PARTY_SERVICE_STATUS_TYPES?.TYPE === 'Active'"
						(click)="!element.ACTIVE && element.FEDERAL_CODES_ID ? null : toggleActive(element.ID, element.SERVICE_NAME, element.PARTY_SERVICE_STATUS_TYPES?.TYPE)"
						[disabled]="!element.ACTIVE && element.FEDERAL_CODES_ID">
						<mat-icon>check_box</mat-icon>
					</button>
					<button mat-icon-button color="primary" matTooltip="Toggle Status"
						*ngIf="element.PARTY_SERVICE_STATUS_TYPES?.TYPE !== 'Active'"
						(click)="!element.ACTIVE && element.FEDERAL_CODES_ID ? null : toggleActive(element.ID, element.SERVICE_NAME, element.PARTY_SERVICE_STATUS_TYPES?.TYPE)"
						[disabled]="!element.ACTIVE && element.FEDERAL_CODES_ID">
						<mat-icon>check_box_outline_blank</mat-icon>
					</button>

				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="REGION.CODE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Region </mat-header-cell>
				<mat-cell *matCellDef="let element"> {{element.REGION.CODE}} </mat-cell>
			</ng-container>

			<ng-container matColumnDef="SERVICE_CODE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Local Service Code </mat-header-cell>
				<mat-cell *matCellDef="let element"> {{element.SERVICE_CODE}} </mat-cell>
			</ng-container>

			<ng-container matColumnDef="FEDERAL_CODES.SERVICE_CODE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> State Service Code </mat-header-cell>
				<mat-cell *matCellDef="let element"> {{element.FEDERAL_CODES?.SERVICE_CODE}} </mat-cell>
			</ng-container>

			<ng-container matColumnDef="SERVICE_NAME">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
				<mat-cell *matCellDef="let element"> {{element.SERVICE_NAME}}</mat-cell>
			</ng-container>

			<ng-container matColumnDef="MEASURABLE_PROGRAM_OBJECTIVES.MPO_NUMBER">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Measurable Program Objective
				</mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div *ngIf="element.MEASURABLE_PROGRAM_OBJECTIVES">
						{{element.MEASURABLE_PROGRAM_OBJECTIVES?.MPO_NUMBER | number: '1.1-1'}}
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="SSDP_COMPONENTS[0].NAME">
				<mat-header-cell *matHeaderCellDef mat-sort-header> SDP Components </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<ul class="row">
						<li class="col-lg-12" *ngFor="let ssdpComponent of element.SSDP_COMPONENTS">
							{{ssdpComponent.NAME}}
						</li>
					</ul>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="PARENT_SERVICE_TYPES.TYPE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Federal Category </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div class="row">
						<div class="col-lg-12">
							{{element.PARENT_SERVICE_TYPES?.TYPE}}
						</div>
						<h5 class="col-lg-12" *ngIf="element.CHILD_SERVICE_TYPES">
							- {{element.CHILD_SERVICE_TYPES?.TYPE}}
						</h5>
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="SERVICE_CATEGORIES.CATEGORY">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Service Category </mat-header-cell>
				<mat-cell *matCellDef="let element"> {{element.SERVICE_CATEGORIES?.CATEGORY}}
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="GRADES_FLAT">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Grade Ranges </mat-header-cell>
				<mat-cell *matCellDef="let element"> {{element.GRADES_FLAT ? element.GRADES_FLAT : 'All'}}
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="ENROLLMENT_PERIODS_FLAT">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Service Periods </mat-header-cell>
				<mat-cell *matCellDef="let element"> {{element.ENROLLMENT_PERIODS_FLAT}}
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="ADD" disabled>
				<mat-header-cell *matHeaderCellDef>
					<button mat-raised-button color="primary" (click)="openDialog('Add')"
						*ngIf="featurePermissions && featurePermissions['Create Service Administrations']">Add New
						Service</button>
				</mat-header-cell>
			</ng-container>

			<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
			<mat-row *matHeaderRowDef="newDisplayedColumns"
				[hidden]="featurePermissions && !featurePermissions['Create Service Administrations']"></mat-row>
			<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
		</mat-table>
	</div>

	<mat-paginator #paginators [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
		aria-label="Select page of periodic elements" [hidden]="results.length <= 0">
	</mat-paginator>
</div>